import React from "react";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import Footerweb from "../../components/layout/footer/Footerweb";
import Headerweb from "../../components/layout/header/Headerweb";
import { commonErrMsg, login, processing } from "../../locales/en";
import { useSelector } from "react-redux";
import "./../../assets/scss/login.scss";
import EmailField from "./EmailField";
import PasswordField from "./PasswordField";
import TwoFaField from "./TwoFaField";

import useLogin from "../../hooks/login/useLogin";
import { RESET_PASSWORD, SIGN_UP } from "../../route/paths";
import {
  CONTACT_SUPPORT,
  CONTACT_SUPPORT_LINK,
  LINK_REL
} from "../../utils/constants/appConstants";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

const Login = () => {
  const environment = process.env.REACT_APP_ENV;
  const { executeRecaptcha } = useGoogleReCaptcha();
  const {
    values,
    errors,
    loading,
    success,
    twoFAVerification,
    twoFAVerificationButton,
    loginSubmitButton,
    qrCodeUrl,
    qrCodeVisible,
    errorMessage,
    handleInputChange,
    handleClickShowPassword,
    handleSentTwoFaQrcode,
    handleSubmit,
    handleSubmitTwoFACode
  } = useLogin(environment, executeRecaptcha);
  const { loginErrorMessage } = useSelector((state) => state.login);

  return (
    <>
      <Headerweb />

      <main>
        <div className="signup-hero-section">
          <div className="container-wrap">
            <div className="hero-content">
              <h1>
                <strong>{login?.mainTitle1}</strong> {login?.mainTitle2}
                <strong>{login?.mainTitle3}</strong>
              </h1>
            </div>
          </div>
        </div>
        <div className="sign-up-wrap">
          <div className="container-wrap">
            <div className="col-row">
              <div className="left-section">
                <div className="about-content">
                  <h4>
                    {login?.text1p1}
                    <strong>{login?.text1p2}</strong>
                    {login?.text1p3}
                  </h4>
                  <p>
                    {login?.text2p1}
                    <br />
                    {login?.text2p2}
                  </p>
                </div>
              </div>
              <div className="right-section">
                <div className="sign-up-form">
                  <div className="fundtap-heading">
                    <h2>{login?.loginBox.subH2}</h2>
                  </div>
                  <form id="login_submit_form" onSubmit={handleSubmit}>
                    <EmailField
                      value={values.email}
                      error={errors.email}
                      disabled={twoFAVerification}
                      onChange={(v) => handleInputChange("email", v)}
                      label={login?.loginBox.emailText}
                    />

                    <PasswordField
                      value={values.password}
                      show={values.showPassword}
                      error={errors.password}
                      disabled={twoFAVerification}
                      onChange={(v) => handleInputChange("password", v)}
                      onToggle={handleClickShowPassword}
                      label={login?.loginBox.passwordText}
                    />

                    {twoFAVerification && (
                      <TwoFaField
                        value={values.twoFactorCode}
                        errors={errors}
                        success={success}
                        loading={loading.reSendTwoFaBtn}
                        onChange={(v) => handleInputChange("twoFactorCode", v)}
                        onResend={handleSentTwoFaQrcode}
                        label={login?.loginBox.havingTrouble}
                        emailText={login?.loginBox.emailText}
                      />
                    )}

                    {errors?.reCaptcha && (
                      <div className="error-message error-message-gray">
                        {errors?.reCaptcha}
                      </div>
                    )}

                    <div className="input-row mt-2">
                      <div className="input-group">
                        <Link to={RESET_PASSWORD} className="forgot-password">
                          {login?.loginBox.forgotBTN}
                        </Link>
                      </div>
                    </div>
                    <div className="input-row">
                      <div className="input-group">
                        {twoFAVerificationButton && (
                          <div className="verifylogin-wrap">
                            <button
                              type="button"
                              className="btn-primary"
                              onClick={handleSubmitTwoFACode}
                              disabled={loading.sendTwoFaBtn}
                            >
                              {loading.sendTwoFaBtn
                                ? processing
                                : login?.loginBox.verifylogin}
                            </button>
                          </div>
                        )}

                        {loginSubmitButton && (
                          <button
                            type="submit"
                            className="btn-primary"
                            disabled={loading.loginBtn}
                          >
                            {loading.loginBtn
                              ? processing
                              : login?.loginBox.subH2}
                          </button>
                        )}
                        <Link to={SIGN_UP} className="get-signup-btn">
                          {login?.loginBox.signUp}
                          <strong>
                            <FaArrowRight />
                          </strong>
                        </Link>

                        {qrCodeVisible && (
                          <>
                            <div className="small-text text-success mt-3">
                              {login?.loginBox.scanQR}
                            </div>
                            <div className="qrcode-wrap">
                              <div className="qrcode-img">
                                <img src={qrCodeUrl} alt="qr" />
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                      {errorMessage && <div>{errorMessage}</div>}
                    </div>

                    {loginErrorMessage.message && (
                      <div className="error-message error-message-gray">
                        {loginErrorMessage?.type === CONTACT_SUPPORT ? (
                          <>
                            {loginErrorMessage.message}
                            <div className="mt-1">
                              {`${commonErrMsg?.item16} `}
                              <Link
                                to={CONTACT_SUPPORT_LINK}
                                target="_blank"
                                rel={LINK_REL}
                              >
                                {commonErrMsg?.item17}
                              </Link>
                            </div>
                          </>
                        ) : (
                          loginErrorMessage?.message || loginErrorMessage
                        )}
                      </div>
                    )}

                    {errors.general && (
                      <p className="error-message">{errors.general}</p>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footerweb />
    </>
  );
};

export default Login;
